import styled from 'styled-components';

export const LabelStyle = styled.label`
	white-space: nowrap;
	margin-bottom: 0;
	width: ${props => (props.isCrepdec ? '13em' : '9em')};
	overflow: hidden; /* "overflow" value must be different from "visible" */
	text-overflow: ellipsis;
`;

export const AbbrStyle = styled.abbr`
	border-bottom: none !important;
	cursor: pointer !important; //cursor para o checkBox
	text-decoration: none !important;
`;

export const InputStyle = styled.input`
	display: ${props => (props.styleInput ? 'inline' : 'none')};
`;
